import "./import/modules";
import "./import/select2/select2";
import "./import/inputmask/inputmask";
import "./import/slick";
import moment from "moment";
import "moment-timezone";

const mediaQuerySlider = window.matchMedia("(max-width: 768px)");
const mediaQueryOfficesSlider = window.matchMedia("(max-width: 650px)");
const $preloader = document.querySelector(".js-preloader");

let hidePreloader = () => {
  setTimeout(function () {
    $preloader.classList.add("hide");
  }, 600);
};

let checkVideoLength = () => {
  if ($preloader) {
    let intervalId = setInterval(function () {
      if (!$(".common__video").length) {
        hidePreloader();
        clearInterval(intervalId);
      }
    }, 100);
  }
};


const $filterList = $(".js-show-list-main");
const $showMoreInside = $(".js-show-more-inside");

const $dropBtn = document.querySelectorAll(".js-drop-btn");

checkVideoLength();

if ($dropBtn) {
$dropBtn.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.currentTarget.classList.toggle("active");
  });
});
}

function reveal() {
var reveals = document.querySelectorAll(".animate__block");

const scrollHeight = window.scrollY;

if (scrollHeight > 0) {
  document.querySelector(".js-header").classList.add("fixed");
  $(`.js-animate`).removeClass("animate");
} else {
  document.querySelector(".js-header").classList.remove("fixed");
  $(`.js-animate`).addClass("animate");
}

if (scrollHeight > window.innerHeight) {
  document.querySelector(".js-btn-up") && document.querySelector(".js-btn-up").classList.add("active");
} else {
  document.querySelector(".js-btn-up") && document.querySelector(".js-btn-up").classList.remove("active");
}

for (var i = 0; i < reveals.length; i++) {
  var windowHeight = window.innerHeight;
  var elementTop = reveals[i].getBoundingClientRect().top;
  var elementVisible = 70;

  if (elementTop < windowHeight - elementVisible) {
    reveals[i].classList.add("animate__active");
  } else {
    reveals[i].classList.remove("animate__active");
  }
}
}

const $backBtn = $('.js-close-modal-case');

if ($backBtn) {
$backBtn.on('click', function () {
  history.back()
})
}

const scrollHeight = $(window).scrollTop();

if (scrollHeight > 100 && $(".js-header")) {
$(".js-header").addClass("fixed");
}

setTimeout(() => {
$(".modal").addClass("visible");
}, 1000);

window.addEventListener("scroll", reveal);
window.addEventListener("load", reveal);

var $anchors = document.querySelectorAll(".js-anchors");

if ($anchors) {
$anchors.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.preventDefault();
    const link = e.currentTarget.getAttribute("href").slice(1);

    e.currentTarget.classList.remove("open");

    if (document.querySelector(".js-menu")) {
      $(".js-btn-menu").removeClass("open");
      document.querySelector(".js-menu").classList.remove("active");
      $("body").removeClass("overflow");
    }

    if (link === "casess") {
      window.scrollTo({
        top:
          document.querySelector(`#element`).offsetTop +
          document.querySelector(`#${link}`).offsetTop -
          150,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: document.querySelector(`#${link}`).offsetTop - 50,
        behavior: "smooth",
      });
    }
  });
});
}

const $btnMenu = document.querySelector(".js-btn-menu");

if ($btnMenu) {
$btnMenu.addEventListener("click", (e) => {
  if (!$btnMenu.classList.contains("open")) {
    e.currentTarget.classList.add("open");
    document.querySelector(".js-menu").classList.add("active");
    document.querySelector("body").classList.add("overflow");
  } else {
    e.currentTarget.classList.remove("open");
    document.querySelector(".js-menu").classList.remove("active");
    document.querySelector("body").classList.remove("overflow");
  }
});
}

const $btnCloseModal = document.querySelectorAll(".js-close-modal");

if ($btnCloseModal) {
$btnCloseModal.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.currentTarget.closest(".modal").classList.remove("active");
    document.querySelector("body").classList.remove("overflow");

    if (document.querySelector(".js-modal-video")) {
      document.querySelector(".modal__video").muted = true;
      document.querySelector(".modal__video").pause();
      document.querySelector(".modal__video").currentTime = 0;
    }
  });
});
}

const $btnCloseModalShort = document.querySelectorAll(
".js-close-modal-short"
);

if ($btnCloseModalShort) {
$btnCloseModalShort.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.currentTarget.closest(".js-short-form-modal").classList.remove("active");

    setTimeout(() => {
      document
        .querySelector(".js-short-form-modal")
        .classList.remove("transition");
    }, 200);
    setTimeout(() => {
      document.querySelector(".js-short-form-modal").classList.remove("over");
    }, 300);

    document.querySelector("body").classList.remove("overflow");
  });
});
}

const $btnModal = document.querySelectorAll(".js-btn-modal");

if ($btnModal) {
$btnModal.forEach((item) => {
  item.addEventListener("click", (e) => {
    document.querySelector(".js-modal").classList.add("active");
    document.querySelector("body").classList.add("overflow");
    document.getElementById("field_click_from").value = item.value;
    if (window.ANALYTICS_ENABLED == true) {
      (dataLayer = window.dataLayer || []).push({
        eCategory: "Button",
        eAction: "click",
        eLabel: "Start project",
        event: "GTMForms",
      });
    }
  });
});
}

const $btnModalShort = document.querySelectorAll(".js-btn-modal-short");

if ($btnModalShort) {
$btnModalShort.forEach((item) => {
  item.addEventListener("click", (e) => {
    document.querySelector(".js-short-form-modal").classList.add("over");
    setTimeout(() => {
      document.querySelector(".js-short-form-modal").classList.add("transition");
    }, 5);
    setTimeout(() => {
      document.querySelector(".js-short-form-modal").classList.add("active");
    }, 15);
    document.querySelector("body").classList.add("overflow");
    document.getElementById("field_click_from").value = item.value;
    if (window.ANALYTICS_ENABLED == true) {
      (dataLayer = window.dataLayer || []).push({
        eCategory: "Button",
        eAction: "click",
        eLabel: "Start project",
        event: "GTMForms",
      });
    }
  });
});
}

const $modal = document.querySelectorAll(".modal");

document.addEventListener("keydown", function (e) {
if (e.keyCode == 27) {
  $modal.forEach((item) => {
    item.classList.remove("active");
    document.querySelector("body").classList.remove("overflow");

    if (document.querySelector(".js-modal-video")) {
      document.querySelector(".modal__video").muted = true;
      document.querySelector(".modal__video").pause();
      document.querySelector(".modal__video").currentTime = 0;
    }
  });
}
});

document.addEventListener("keydown", function (e) {
const $modalShort = document.querySelector(".js-short-form-modal");

if (e.keyCode == 27) {
  $modalShort.classList.remove("active");

  setTimeout(() => {
    $modalShort.classList.remove("transition");
  }, 100);
  setTimeout(() => {
    $modalShort.classList.remove("over");
  }, 200);

  document.querySelector("body").classList.remove("overflow");

  if (document.querySelector(".js-modal-video")) {
    document.querySelector(".modal__video").muted = true;
    document.querySelector(".modal__video").pause();
    document.querySelector(".modal__video").currentTime = 0;
  }
}
});

$(".modal").mouseup(function (e) {
// событие клика по веб-документу
var div = $(".modal__inner"); // тут указываем ID элемента
if (
  !div.is(e.target) && // если клик был не по нашему блоку
  div.has(e.target).length === 0
) {
  // и не по его дочерним элементам
  $modal.forEach((item) => {
    item.classList.remove("active");
    document.querySelector("body").classList.remove("overflow");
  });
}
});

$(".js-short-form-modal").mouseup(function (e) {
// событие клика по веб-документу
var div = $(".common__inner"); // тут указываем ID элемента
if (
  !div.is(e.target) && // если клик был не по нашему блоку
  div.has(e.target).length === 0
) {
  // и не по его дочерним элементам
  $(".js-short-form-modal").removeClass("active");

  setTimeout(() => {
    $(".js-short-form-modal").removeClass("transition");
  }, 100);
  setTimeout(() => {
    $(".js-short-form-modal").removeClass("over");
  }, 200);

  $("body").removeClass("overflow");
}
});

const $btnModalVideo = document.querySelector(".js-btn-modal-video");

if ($btnModalVideo) {
$btnModalVideo.addEventListener("click", (e) => {
  document.querySelector(".js-modal-video").classList.add("active");
  document.querySelector(".modal__video").play();
  document.querySelector("body").classList.add("overflow");
});
}

var vid = document.querySelector(".common__video");

if (vid) {
var wrapper = document.querySelector(".js-current-color");
var canvas = document.querySelector(".main__banner-fake");
var ctx = canvas.getContext("2d");

var ratio = window.devicePixelRatio || 1;
var vidWidth;
var vidHeight;

vid.addEventListener("loadedmetadata", function (e) {
  console.log("onloadedmetadata");
  vid.style.transform = `scale(${ratio})`;

  vidWidth = vid.videoWidth;
  vidHeight = vid.videoHeight;

  canvas.width = vid.offsetWidth * ratio;
  canvas.height = vid.offsetHeight * ratio;

  canvas.style.width = vid.offsetWidth + "px";
  canvas.style.height = vid.offsetHeight + "px";

  drawingLoop();

  //resize scale for comparison
  vid.style.transform = `scale(.7)`;

  if ($preloader) {
    hidePreloader();
  }
});

vid.addEventListener("loadeddata", function (e) {
  console.log("onloadeddata");
  setVideoBgColor(vid, wrapper);
  vid.play();
});

function drawingLoop() {
  window.requestAnimationFrame(drawingLoop);

  ctx.drawImage(
    vid,
    0,
    0,
    vidWidth,
    vidHeight, // source rectangle
    0,
    0,
    canvas.width,
    canvas.height
  ); // destination rectangle);
}

function setVideoBgColor(vid, backgroundElement) {
  var canvas = document.createElement("canvas");
  canvas.width = 8;
  canvas.height = 8;

  var ctx = canvas.getContext("2d");
  ctx.drawImage(vid, 0, 0, 8, 8);

  var p = ctx.getImageData(0, 0, 8, 8).data;
  //dont take the first but fourth pixel [r g b]
  backgroundElement.style.backgroundColor =
    "rgb(" + p[60] + "," + p[61] + "," + p[62] + ")";
}

window.onresize = function (event) {
  vid.style.transform = `scale(.7)`;

  vidWidth = vid.videoWidth;
  vidHeight = vid.videoHeight;

  canvas.width = vid.offsetWidth * ratio;
  canvas.height = vid.offsetHeight * ratio;

  canvas.style.width = vid.offsetWidth + "px";
  canvas.style.height = vid.offsetHeight + "px";

  ctx.drawImage(
    vid,
    0,
    0,
    vidWidth,
    vidHeight,
    0,
    0,
    canvas.width,
    canvas.height
  );

  vid.style.transform = `scale(.7)`;
};

vid.src = vid.dataset.src;
vid.play();

(function () {
  var fixAutoPlay = function (e) {
    document.removeEventListener("touchstart", fixAutoPlay);
    document.removeEventListener("touchend", fixAutoPlay);
    document.removeEventListener("scroll", fixAutoPlay);
  };
  document.addEventListener("touchstart", fixAutoPlay);
  document.addEventListener("touchend", fixAutoPlay);
  document.addEventListener("scroll", fixAutoPlay);
})();
}

const $langSelect = $(".js-select-lang");

if ($langSelect) {
$langSelect.select2({
  minimumResultsForSearch: -1,
  containerCssClass: "select-lang",
  dropdownCssClass: "drop-lang",
  width: "max-content",
});

$(".select-lang")
  .find(".select2-selection__rendered")
  .text($langSelect.find("option:selected").val());

$langSelect.on("change", function () {
  const val = $(this).find(":selected").val();
  $(".select-lang").find(".select2-selection__rendered").text(val);
});
}

const validate = (element) => {
const $formValidate = element.closest(".js-form");

const $formInputReq = $formValidate.querySelectorAll(
  "input[required], textarea[required]"
);

$formInputReq.forEach((item) => {
  if (item.getAttribute("type") !== "checkbox" && item.value == "") {
    item.closest(".js-form-item").classList.add("error-item");
  }

  if (item.getAttribute("type") !== "checkbox" && item.value !== "") {
    item.closest(".js-form-item").classList.remove("error-item");
  }

  if (item.getAttribute("type") == "checkbox" && !item.checked) {
    item.closest(".js-form-item").classList.add("error-item");
  }

  if (item.getAttribute("type") == "checkbox" && item.checked) {
    item.closest(".js-form-item").classList.remove("error-item");
  }
});

if ($formValidate.querySelector("#id_other_field_value")) {
  if (
    $formValidate
      .querySelector("#id_other_field_value")
      .getAttribute("required") &&
    $formValidate.querySelector("#id_other_field_value").value == ""
  ) {
    return;
  } else {
    const filterArr = [
      ...$formValidate
        .querySelector(".js-form-goals")
        .querySelectorAll(".form__check-hidden"),
    ].filter((item) => item.checked);
    filterArr.length
      ? $formValidate
        .querySelector(".js-form-goals")
        .classList.remove("error-item")
      : $formValidate
        .querySelector(".js-form-goals")
        .classList.add("error-item");
  }
}

if (window.mask) {
  const $formCheckReq = $formValidate.querySelector("#id_i_agree");
  const $formGoalReq = $formValidate.querySelectorAll(
    ".form__check-hidden"
  );
  const $btnSubmit = $formValidate.querySelector('button[type="submit"');

  const disableBtnSubmit = () => {
    $btnSubmit.disabled = true;
  };

  const activateBtnSubmit = () => {
    $btnSubmit.removeAttribute("disabled");
  };

  let checkAgreeArray = [];
  let checkGoalArray = [];
  let inputReqArray = [];

  $formInputReq.forEach(function (item) {
    if (item.getAttribute("name") !== "phone_number") {
      if (!item.value) {
        inputReqArray.push(item);
      }
    } else {
      if (mask.unmaskedValue === "") {
        inputReqArray.push(item);
      }
    }
  });

  if (!$formCheckReq.checked) {
    checkAgreeArray.push($formCheckReq);
  }

  if ($formGoalReq.length > 0) {
    $formGoalReq.forEach(function (item) {
      if (item.value !== "OTHER") {
        if (
          item.checked &&
          !$formValidate.querySelector('[value="OTHER"]').checked
        ) {
          checkGoalArray.push(item);
        } else if (
          item.ckecked &&
          $formValidate.querySelector('[name="OTHER"]').ckecked
        ) {
          if (
            $formValidate.querySelector("#id_other_field_value").value
              .length > 0
          ) {
            checkGoalArray.push(item);
          }
        }
      } else {
        if (
          item.checked &&
          $formValidate.querySelector("#id_other_field_value").value
            .length > 0
        ) {
          checkGoalArray.push(item);
        }
      }
    });
  }

  if ($formGoalReq.length > 0) {
    if (
      checkAgreeArray.length < 1 &&
      !inputReqArray.length &&
      checkGoalArray.length > 0
    ) {
      activateBtnSubmit();
    } else {
      disableBtnSubmit();
    }
  } else {
    if (checkAgreeArray.length < 1 && !inputReqArray.length) {
      activateBtnSubmit();
    } else {
      disableBtnSubmit();
    }
  }
}
};

const $otherGoalCheckbox = $('[name="goal"][value="OTHER"]');
const $otherGoalValueInput = $('input[name="other_field_value"]');

$otherGoalCheckbox.change((e) => {
if ($otherGoalCheckbox.is(":checked")) {
  $otherGoalValueInput.removeAttr("disabled");
  $otherGoalValueInput.attr("required", true);
  $otherGoalValueInput.closest("div").show();
} else {
  $otherGoalValueInput.attr("disabled", "disabled").val("");
  $otherGoalValueInput.attr("required", false);
  $otherGoalValueInput.closest("div").hide();
}

validate(e.currentTarget);
});

$("[required]").on("blur", (e) => {
validate(e.currentTarget);
});

document.querySelectorAll("#id_i_agree").forEach((item) => {
item.addEventListener("change", (e) => {
  validate(e.currentTarget);
});
});

$(".form__check-hidden").on("change", (e) => {
validate(e.currentTarget);
});

$("#id_other_field_value").on("blur", (e) => {
validate(e.currentTarget);
});

document.querySelectorAll("#id_other_field_value").forEach((item) => {
item.addEventListener("change", (e) => {
  validate(e.currentTarget);
});
});

const $btnUp = $(".js-btn-up");

if ($btnUp) {
$btnUp.on("click", function () {
  $(window).scrollTop(0);

  if ($(window).width() < 768) {
    $btnUp.addClass("active");

    setTimeout(function () {
      $btnUp.removeClass("active");
    }, 500);
  }
});
}

const $selectMask = $(".js-select-phone");

if ($selectMask) {
$selectMask.prepend('<option selected=""></option>');

$selectMask
  .select2({
    width: "100%",
    dropdownCssClass: "select-phone-dropdown",
    containerCssClass: "select-phone-custom",
    allowClear: true,
    placeholder: "Quick search",
  })
  .on("select2:open", function (event) {
    $("input.select2-search__field").attr("placeholder", "Quick search");
  });

$selectMask.on("select2:select", (e) => {
  const country = e.params.data.element.getAttribute("data-flag");
  const code = e.params.data.id;

  e.currentTarget
    .closest(".form__item-phone")
    .querySelector(".js-flag-img")
    .classList.remove("flag-doesnt-exist");

  e.currentTarget
    .closest(".form__item-phone")
    .querySelector(".js-flag-img").innerHTML = country;

  const element = e.currentTarget
    .closest(".form__item-phone")
    .querySelector('input[name="phone_number"]');

  let mask = IMask(element, {
    mask: `(000) 000-00-00`,
    normalizeZeros: true,
    lazy: true,
    placeholderChar: "_",
  });

  window.mask = mask;

  e.currentTarget
    .closest(".form__item-phone")
    .querySelector(".js-flag-code").innerText = code;

  element.classList.add("active");
  element.focus();
});
}

const $accomSlider = $(".js-service-slider");

const $certSlider = $(".js-certificates-slider");

const slickSettings = {
slidesToShow: 1,
slidesToScroll: 1,
autoplay: true,
autoplaySpeed: 3000,
dots: true,
arrows: false,
pauseOnSelect: false,
focusOnSelect: false,
pauseOnHover: false,
pauseOnDotsHover: false,
};

$accomSlider.on("touchend touchcancel touchmove", (e) => {
$accomSlider.slick("slickPlay");
});

const certSetting = {
slidesToShow: 1,
slidesToScroll: 1,
centerMode: true,
variableWidth: true,
autoplay: true,
autoplaySpeed: 2000,
};

if (mediaQuerySlider.matches) {
$accomSlider.slick(slickSettings);
$certSlider.slick(certSetting);
}

$(window).on("resize", () => {
if (mediaQuerySlider.matches) {
  if (!$accomSlider.hasClass("slick-initialized")) {
    $accomSlider.slick(slickSettings);
  }

  if (!$certSlider.hasClass("slick-initialized")) {
    $certSlider.slick(certSetting);
  }
} else {
  if ($accomSlider.hasClass("slick-initialized")) {
    $accomSlider.slick("unslick");
  }

  if ($certSlider.hasClass("slick-initialized")) {
    $certSlider.slick("unslick");
  }
}

if (mediaQueryOfficesSlider.matches) {
  $(".offices__section-list").each(function (index) {
    if (
      $(this).data("slide") === 4 &&
      $(this).hasClass("slick-initialized")
    ) {
      $(this).slick("unslick");
    }
  });
} else {
  $(".offices__section-list").each(function (index) {
    if (
      $(this).data("slide") === 4 &&
      !$(this).hasClass("slick-initialized")
    ) {
      $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: true,
        prevArrow: $(this)
          .closest(".offices__section")
          .find(".slider__button-prev"),
        nextArrow: $(this)
          .closest(".offices__section")
          .find(".slider__button-next"),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 560,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      });
    }
  });
}
});

$("body")
.find(".slick-dots")
.on("touchend touchcancel touchmove", (e) => {
  $accomSlider.slick("slickPlay");
});

const $btnShowMore = $(".js-show-more");

if ($btnShowMore) {
$btnShowMore.on("click", function () {
  $(this).addClass("active");
  $(this).prev(".js-show-list").addClass("active");
});
}

const sliderList = $(".offices__section-list");

if (sliderList) {
$(".offices__section-list").each(function (index) {
  if ($(this).data("slide") === 4 && !mediaQueryOfficesSlider.matches) {
    $(this).slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      arrows: true,
      prevArrow: $(this)
        .closest(".offices__section")
        .find(".slider__button-prev"),
      nextArrow: $(this)
        .closest(".offices__section")
        .find(".slider__button-next"),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 560,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });
  }

  if ($(this).data("slide") === 3) {
    $(this).slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows: true,
      prevArrow: $(this)
        .closest(".offices__section")
        .find(".slider__button-prev"),
      nextArrow: $(this)
        .closest(".offices__section")
        .find(".slider__button-next"),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 560,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });
  }
});
}

const filterButton = $(".js-button-filter");
const cases = $("[data-filter]");

let filterCases = (filter) => {
cases.each(function () {
  $(this).removeAttr("style");
  $(this).data("filter") === filter
    ? $(this).addClass("active")
    : $(this).removeClass("active");
});

if (mediaQueryOfficesSlider.matches) {
  $filterList.find(".active").each(function (index) {
    index > 2 && $(this).hide();
  });

  $showMoreInside.removeClass("active");
} else {
  $filterList.removeAttr("style");
}
};

window.filterCases = filterCases;

if (filterButton) {
filterCases("cpa");

filterButton.on("click", function () {
  filterButton.removeClass("active");
  $(this).addClass("active");
  filterCases($(this).data("filter-button"));
});
}

if ($filterList && mediaQuerySlider.matches) {
$filterList.find(".active").each(function (index) {
  index > 2 && $(this).hide();
});

$showMoreInside.on("click", function () {
  $filterList.find(".active").show();
  $(this).addClass("active");
});
}

const rotate = (degrees, hand) => {
  hand.css({ transform: `rotate(${degrees}deg)` });
};

const calcDegrees = (country, hours, minutes) => {
  let hourHand = $(`[data-country="${country}"]`).find(".hand");
  let minuteHand = $(`[data-country="${country}"]`).find(".minute");
  let degreesHours = (hours / 12) * 360 + 0.5 * minutes;
  let degreesMinutes = minutes * 6;

  rotate(degreesHours, hourHand);
  rotate(degreesMinutes, minuteHand);
};

let hourIndia = moment().tz("Asia/Kolkata").hour();
let minutesIndia = moment().tz("Asia/Kolkata").minutes();

let hourIsrael = moment().tz("Asia/Jerusalem").hour();
let minutesIsrael = moment().tz("Asia/Jerusalem").minutes();

let hourUae = moment().tz("Asia/Dubai").hour();
let minutesUae = moment().tz("Asia/Dubai").minutes();

let hourCyprus = moment().tz("Asia/Nicosia").hour();
let minutesCyprus = moment().tz("Asia/Nicosia").minutes();

let hourIndonezia = moment().tz("Asia/Jakarta").hour();
let minutesIndonezia = moment().tz("Asia/Jakarta").minutes();

let hourSpain = moment().tz("Europe/Madrid").hour();
let minutesSpain = moment().tz("Europe/Madrid").minutes();

calcDegrees("india", hourIndia, minutesIndia);
calcDegrees("israel", hourIsrael, minutesIsrael);
calcDegrees("uae", hourUae, minutesUae);
calcDegrees("cyprus", hourCyprus, minutesCyprus);
calcDegrees("indonezia", hourIndonezia, minutesIndonezia);
calcDegrees("spain", hourSpain, minutesSpain);

setInterval(() => {
  let hourIndia = moment().tz("Asia/Kolkata").hour();
  let minutesIndia = moment().tz("Asia/Kolkata").minutes();

  let hourIsrael = moment().tz("Asia/Jerusalem").hour();
  let minutesIsrael = moment().tz("Asia/Jerusalem").minutes();

  let hourUae = moment().tz("Asia/Dubai").hour();
  let minutesUae = moment().tz("Asia/Dubai").minutes();

  let hourCyprus = moment().tz("Asia/Nicosia").hour();
  let minutesCyprus = moment().tz("Asia/Nicosia").minutes();

  let hourIndonezia = moment().tz("Asia/Jakarta").hour();
  let minutesIndonezia = moment().tz("Asia/Jakarta").minutes();

  let hourSpain = moment().tz("Europe/Madrid").hour();
  let minutesSpain = moment().tz("Europe/Madrid").minutes();

  calcDegrees("india", hourIndia, minutesIndia);
  calcDegrees("israel", hourIsrael, minutesIsrael);
  calcDegrees("uae", hourUae, minutesUae);
  calcDegrees("cyprus", hourCyprus, minutesCyprus);
  calcDegrees("indonezia", hourIndonezia, minutesIndonezia);
  calcDegrees("spain", hourSpain, minutesSpain);
}, 60000);

$(window).on("resize", function () {
  let hourIndia = moment().tz("Asia/Kolkata").hour();
  let minutesIndia = moment().tz("Asia/Kolkata").minutes();

  let hourIsrael = moment().tz("Asia/Jerusalem").hour();
  let minutesIsrael = moment().tz("Asia/Jerusalem").minutes();

  let hourUae = moment().tz("Asia/Dubai").hour();
  let minutesUae = moment().tz("Asia/Dubai").minutes();

  let hourCyprus = moment().tz("Asia/Nicosia").hour();
  let minutesCyprus = moment().tz("Asia/Nicosia").minutes();

  let hourIndonezia = moment().tz("Asia/Jakarta").hour();
  let minutesIndonezia = moment().tz("Asia/Jakarta").minutes();

  let hourSpain = moment().tz("Europe/Madrid").hour();
  let minutesSpain = moment().tz("Europe/Madrid").minutes();

  calcDegrees("india", hourIndia, minutesIndia);
  calcDegrees("israel", hourIsrael, minutesIsrael);
  calcDegrees("uae", hourUae, minutesUae);
  calcDegrees("cyprus", hourCyprus, minutesCyprus);
  calcDegrees("indonezia", hourIndonezia, minutesIndonezia);
  calcDegrees("spain", hourSpain, minutesSpain);

  window.filterCases($(".js-button-filter.active").data("filter-button"));
});
